import { useDataValue } from 'Simple/Data.js'
import startOfDay from 'date-fns/startOfDay'
import endOfDay from 'date-fns/startOfDay'
import format from 'date-fns/format'

function getFilterConditions(filters) {
  let conditions = []

  if (filters.stage_ids?.length) {
    conditions.push({ stage_id: { _in: filters.stage_ids } })
  }
  if (filters.board_ids?.length) {
    conditions.push({ board_id: { _in: filters.board_ids } })
  }
  if (filters.location_ids?.length) {
    conditions.push({ location_id: { _in: filters.location_ids } })
  }
  if (filters.priorities?.length) {
    conditions.push({ priority: { _in: filters.priorities } })
  }
  if (filters.assignee_ids?.length) {
    conditions.push({ assignees: { user_id: { _in: filters.assignee_ids } } })
  }
  if (filters.tag_ids?.length) {
    conditions.push({ task_tags: { tag_id: { _in: filters.tag_ids } } })
  }
  if (filters.is_past_due_date) {
    conditions.push({ due_date: { _lt: 'now' } })
  }
  // the due date doesn't have a timezone, we'll keep date as plain sql timetamps
  if (filters.due_date?.from && filters.due_date?.to) {
    conditions.push({
      due_date: {
        _gte: format(
          startOfDay(new Date(filters.due_date.from)),
          'yyyy-MM-dd HH:mm:ss'
        ),
        _lte: format(
          endOfDay(new Date(filters.due_date.to)),
          'yyyy-MM-dd HH:mm:ss'
        ),
      },
    })
  }

  if (filters.patient_ids?.length) {
    conditions.push({
      patients: {
        _id: { _in: filters.patient_ids },
      },
    })
  }

  return conditions
}

export default function useDataConfiguration(props) {
  let user_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'user.id',
  })

  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  let view = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'submenu_tab_id',
  })

  let filters = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'filters',
  })

  return {
    variables: {
      view,
      user_id,
      location_id,
      filters: getFilterConditions(filters),
    },
  }
}
